import actionTypes from 'SRC/modules/redux/actionTypes'

export const setUserType = userType => ({
  type: actionTypes.SET_USERS_LIST_USER_TYPE,
  payload: userType
})
